export default __webpack_public_path__ + "2965186f7381bbb30e814580586d56aa.png";